import React, { useState,useEffect } from 'react'
import Navbar from './components/Navbar'
import Home from './pages/Home'
import AlertMessage from './components/AlertMessage'
import LoginBox from './components/LoginBox'
import LogoutBox from './components/LogoutBox'
import axios from "axios";
import { BACKEND_URL } from './components/URL'
// import { batch_type_dict } from '../components/Data';

const App = () => {
  const [alertMessage, setAlertMessage] = useState("");
  const [batchType,setBatchType]=useState("ADDRESS");
  const [BatchTypeDict,setBatchTypeDict] = useState({
    "ADDRESS":"Address",
    "GPS":"GPS"
});
  const [showAlert, setShowAlert] = useState(false);
  const [flap,setFlap]=useState(true);
  const [isSingle,setIsSingle]=useState(false);
  const [isBatch,setIsBatch]=useState(false);
  const [user, setLoginUser] = useState(() => {
    const storedUser = sessionStorage.getItem("uinfo");
    try {
      return storedUser ? JSON.parse(storedUser) : {};
    } catch (error) {
      console.error("Error parsing stored user data:", error);
      return {};
    }
  });

  useEffect(() => {
    sessionStorage.setItem("uinfo", JSON.stringify(user));
  }, [user]);

  const refreshQuota = async ()=>{
    const payload={
        username:user.username,
    };
    try {
        const response = await axios.post(`${BACKEND_URL}/get_quota`, payload);
        if (response.data.status === 'done'){
          const temp=JSON.parse(sessionStorage.getItem("uinfo"));
          temp.allocated_quota=response.data.allocated_quota;
          temp.used_quota=response.data.used_quota;
          setLoginUser(temp);
        }
        else{
          setAlertMessage("Unable to refresh quota");
          setShowAlert(true);
        }
       
        

      } catch (error) {
        console.error('Error fetching quota', error);
      }

}




  return (
    <div>
      {alertMessage && <AlertMessage text={alertMessage} showAlert={showAlert}
        setShowAlert={setShowAlert} />}

      <Navbar/>
      {flap ? <LoginBox flap={flap} setFlap={setFlap} setBatchType={setBatchType} setBatchTypeDict={setBatchTypeDict} setIsSingle={setIsSingle} setIsBatch={setIsBatch} setLoginUser={setLoginUser} setAlertMessage={setAlertMessage} setShowAlert={setShowAlert}/>:<LogoutBox user={user} flap={flap}  setFlap={setFlap} setLoginUser={setLoginUser} setAlertMessage={setAlertMessage} setShowAlert={setShowAlert} refreshQuota={refreshQuota}/> }
      <Home setAlertMessage={setAlertMessage} BatchTypeDict={BatchTypeDict}  batchType={batchType} setBatchType={setBatchType} setShowAlert={setShowAlert} flap={flap} user={user} isSingle={isSingle} isBatch={isBatch}  refreshQuota={refreshQuota} />
    </div>
  )
}

export default App